import React, { Component } from "react";
import { checkTranslation } from "../../utils/useful";

class WindowShots extends Component {
    state = {};
    render() {
        console.log('windoowwwww', this.props.windows);

        return (
            <>
                {window.innerWidth <= 520 ? (
                    <div
                        className="windowshots h-100 scroll-no-scrollbar w-100"
                        style={{
                            width: window.innerWidth,
                            zIndex: 999,
                            // visibility: this.props.showWindowsShots
                            //     ? "visible"
                            //     : "hidden"
                        }}
                    >

                        <div className="my-2 br-10" onClick={() => this.props.minimizeAllWindow()}>
                            <div className="flexcc bg-white windowshots__box box-shadow-30" style={{ border: '1px solid #1e1e1ecc' }}>
                                <img height='50px' className="" src="/images/desktop.png" alt="" />
                            </div>
                            <p className="windowshots__title">Desktop</p>
                        </div>

                        {this.props.windows.map((thisWindow) => {
                            const { id } = thisWindow;
                            { console.log('jjsdbvgljegflkahd', thisWindow) }
                            return (
                                <div
                                    className="my-2 br-10"
                                >
                                    {/* {console.log('ckjdaahfshliddd',thisWindow?.id)} */}
                                    <div className="windowshots__box box-shadow-30" style={{ border: '1px solid #252525cc' }}>
                                        <img
                                            onClick={() => this.props.selectWindow(id)}
                                            className="windowshots__img"
                                            src={thisWindow?.windowScreen}
                                            alt=""
                                        />
                                        <div onClick={() => this.props.closeWindow(id)} className="windowshots__close p-1">
                                            <img src="/assets/icons/close.svg" width={15} className="flexcc" />
                                        </div>
                                    </div>

                                    <div className="windowshots__title">
                                        {/* <div>{thisWindow.type}</div> */}
                                        <p>{checkTranslation(thisWindow?.info?.title) + ' | ' + checkTranslation(thisWindow?.data?.path[0])}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : null}
            </>
        );
    }
}

export default WindowShots;
